<style lang="scss" scoped>
.aside {
  color: #fff;
  height: 100%;
  .info {
    padding: 70px 0 40px;
    text-align: center;
    .logo {
      border-radius: 50%;
      width: 70px;
      margin-bottom: 10px;
    }
    .name {
      font-size: 16px;
    }
  }
}
</style>

<template>
  <el-menu
    :default-active="type"
    class="aside"
    unique-opened
    background-color="#525A65"
    text-color="#fff"
    active-text-color="#17cfb8"
    @select="select"
  >
    <div class="info">
      <img :src="user.head" alt class="logo" />
      <div class="name">{{user.name}}</div>
    </div>
    <el-submenu :index="`/third/${id}/autoReply`">
      <template slot="title">
        <span>自动回复</span>
      </template>
      <el-menu-item :index="`/third/${id}/autoReply/key`">关键词回复</el-menu-item>
      <el-menu-item :index="`/third/${id}/autoReply/message`">收到消息回复</el-menu-item>
      <el-menu-item :index="`/third/${id}/autoReply/focus`">被关注回复</el-menu-item>
    </el-submenu>
    <el-menu-item :index="`/third/${id}/custom`">
      <span slot="title">自定义菜单</span>
    </el-menu-item>
    <el-submenu :index="`/third/${id}/lib`">
      <template slot="title">
        <span>公众号素材管理</span>
      </template>
      <el-menu-item :index="`/third/${id}/lib/article`">图文消息</el-menu-item>
      <el-menu-item :index="`/third/${id}/lib/image`">图片</el-menu-item>
      <el-menu-item :index="`/third/${id}/lib/sound`">语音</el-menu-item>
      <el-menu-item :index="`/third/${id}/lib/video`">视频</el-menu-item>
    </el-submenu>
    <el-submenu :index="`/third/${id}/channel`">
      <template slot="title">
        <span>渠道二维码</span>
      </template>
      <el-menu-item :index="`/third/${id}/channel/create`">生成渠道二维码</el-menu-item>
      <el-menu-item :index="`/third/${id}/channel/edit`">编辑渠道二维码</el-menu-item>
      <el-menu-item :index="`/third/${id}/channel/refer`">二维码数据查询</el-menu-item>
    </el-submenu>
    <el-submenu :index="`/third/${id}/usermana`">
      <template slot="title">
        <span>用户管理</span>
      </template>
      <el-menu-item :index="`/third/${id}/usermana/index`">关注用户</el-menu-item>
      <el-menu-item :index="`/third/${id}/usermana/takeoff`">取关用户</el-menu-item>
    </el-submenu>
    <el-menu-item :index="`/third/${id}/mass`">
      <span slot="title">群发消息管理</span>
    </el-menu-item>
    <el-menu-item :index="`/third/${id}/tag`">
      <span slot="title">平台标签管理</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
const PATHMAP = ['autoReply', 'lib', 'usermana', 'channel'];
export default {
  components: {},
  props: ['id'],
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    '$route.path'(val) {
      let mod = this.$route.path.split('/')[3];
      let num = PATHMAP.includes(mod) ? 5 : 4;
      this.type = this.$route.path
        .split('/')
        .slice(0, num)
        .join('/');
      console.log(this.type);
    },
  },
  data() {
    let mod = this.$route.path.split('/')[3];
    let num = PATHMAP.includes(mod) ? 5 : 4;
    let type = this.$route.path
      .split('/')
      .slice(0, num)
      .join('/');
    return {
      type: type,
    };
  },
  mounted() {},
  methods: {
    select(i) {
      this.$router.push(i);
    },
  },
};
</script>
